import React from 'react';
import styled from '@marvelapp/styled';
import { Box } from '@marvelapp/ui';
const RolesBoxElement = styled(Box) `
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;

  > :first-child {
    border-top: 0px;
  }
`;
export default function RolesBox({ children }) {
    return (React.createElement(RolesBoxElement, { as: "form", borderRadius: 3, boxShadow: "button.ghost", display: "block", my: 4 }, children));
}
